import IActivityLogEntry from "../interface/iActivityLogEntry";

/** Areas whose reference is an appointment id; mirrors readActivityLog::APPOINTMENT_AREAS. */
export const APPOINTMENT_AREAS = [
  "booking",
  "cancellation",
  "appointment",
  "rating",
  "reminder",
];

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** German date for ISO dates; anything else (e.g. raw import cells) stays as it is. */
export const formatDate = (date: string): string => {
  if (!ISO_DATE.test(date)) return date;
  const [year, month, day] = date.split("-");
  return `${day}.${month}.${year}`;
};

/**
 * One line describing the appointment an entry is about, or null when the entry has
 * no appointment.
 */
const formatAppointment = (entry: IActivityLogEntry): string | null => {
  const { appointment } = entry;

  if (!appointment) {
    return entry.subjectRef !== null && APPOINTMENT_AREAS.includes(entry.area)
      ? "Termin gelöscht, Daten nicht mehr vorhanden"
      : null;
  }

  const time = [appointment.from, appointment.till]
    .filter((part): part is string => part !== null)
    .join("–");
  const when = [formatDate(appointment.date), time].filter((part) => part !== "").join(", ");
  const description = [when, appointment.type, appointment.coach]
    .filter((part): part is string => part !== null && part !== "")
    .join(" · ");
  const isDeletionEntry = entry.area === "appointment" && entry.action === "deleted";

  return appointment.deleted && !isDeletionEntry ? `${description} (gelöscht)` : description;
};

export default formatAppointment;
